import { render, staticRenderFns } from "./MonsterSlayer.vue?vue&type=template&id=bebf0a34&"
import script from "./MonsterSlayer.vue?vue&type=script&lang=js&"
export * from "./MonsterSlayer.vue?vue&type=script&lang=js&"
import style0 from "./MonsterSlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports